import { render, staticRenderFns } from "./opportunity-information.vue?vue&type=template&id=623574bd&scoped=true&"
import script from "./opportunity-information.vue?vue&type=script&lang=js&"
export * from "./opportunity-information.vue?vue&type=script&lang=js&"
import style0 from "./opportunity-information.vue?vue&type=style&index=0&id=623574bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623574bd",
  null
  
)

component.options.__file = "opportunity-information.vue"
export default component.exports